function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Text } from '../../Text';
import { DateContainer, StyledRadioSelectionCard, TagContainer } from './elements';
import { Tag } from '../../Tag';
export const DateCard = ({
  weekday,
  date,
  tag = '',
  tagType,
  month,
  ...rest
}) => {
  if (date > 31 || date < 1) date = 1;
  return /*#__PURE__*/React.createElement(StyledRadioSelectionCard, _extends({
    showCircle: false
  }, rest), /*#__PURE__*/React.createElement(DateContainer, null, /*#__PURE__*/React.createElement(TagContainer, null, tag && /*#__PURE__*/React.createElement(Tag, {
    text: tag,
    type: tagType ?? (tag === 'Closed' ? 'light' : 'attention')
  })), /*#__PURE__*/React.createElement(Text, {
    size: 3,
    as: "h2"
  }, weekday.substring(0, 3)), /*#__PURE__*/React.createElement(Text, {
    size: 2
  }, `${month.substring(0, 3)} ${date}`)));
};